import React from 'react';

const generateSizes = (size) => {
  switch (size) {
    case 'small':
      return {
        height: 18,
        width: 18,
        viewBox: '0 0 36 36',
      };
    default:
      return {
        height: 24,
        width: 24,
        viewBox: '0 0 36 36',
      };
  }
};

const Spin = ({ size, operation }) => {
  const data = generateSizes(size);

  // success svg
  if (operation === 'success') {
    return (
      <svg
        height={data.height}
        width={data.width}
        className={`Button_Spin ${operation}`}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 130.2 130.2"
      >
        <circle
          className="path circle"
          fill="none"
          strokeWidth="6"
          strokeMiterlimit="10"
          cx="65.1"
          cy="65.1"
          r="62.1"
        />
        <polyline
          className="path check"
          fill="none"
          strokeWidth="6"
          strokeLinecap="round"
          strokeMiterlimit="10"
          points="100.2,40.2 51.5,88.8 29.8,67.5 "
        />
      </svg>
    );
  }

  // failure svg
  if (operation === 'failure') {
    return (
      <svg
        height={data.height}
        width={data.width}
        className={`Button_Spin ${operation}`}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 130.2 130.2"
      >
        <circle
          className="path circle"
          fill="none"
          strokeWidth="6"
          strokeMiterlimit="10"
          cx="65.1"
          cy="65.1"
          r="62.1"
        />
        <line
          className="path line"
          fill="none"
          strokeWidth="6"
          strokeLinecap="round"
          strokeMiterlimit="10"
          x1="34.4"
          y1="37.9"
          x2="95.8"
          y2="92.3"
        />
        <line
          className="path line"
          fill="none"
          strokeWidth="6"
          strokeLinecap="round"
          strokeMiterlimit="10"
          x1="95.8"
          y1="38"
          x2="34.4"
          y2="92.2"
        />
      </svg>
    );
  }

  // return <Loader type="TailSpin" color="white" height={30} width={30} />;
  // loading svg
  return (
    <svg
      version="1.1"
      id="loader-1"
      height={data.height}
      width={data.width}
      className={`Button_Spin ${operation}`}
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={data.width}
      height={data.height}
      viewBox="0 0 50 50"
      style={{ enableBackground: 'new 0 0 50 50' }}
      xmlSpace="preserve"
    >
      <path
        className="path circle"
        d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
      />
    </svg>
  );
};

export default Spin;
